export default __webpack_public_path__ + "static/portal/img/fig-1.0ee2a58.png";